import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./checkout.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";

import "./modal.css";
import { color } from "framer-motion";

const Checkout = () => {
  const location = useLocation();
  const Subscriptiondata = location.state;
  const [loading, setLoading] = useState(false);

  const Monthlypricing = [
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 4899,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 6199,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 4999,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 4899,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 6599,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 5499,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 4899,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 5130,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 4999,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 4699,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 5499,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 4699,
    },

    // weight loss and diet balanced meal
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 4714,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 5799,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 4999,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 4999,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 6799,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 4999,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 4999,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 5460,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 4799,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 4799,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 5899,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 4599,
    },

    // weight loss and diet ketogenic
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 6000,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 7500,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 7500,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 6000,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 7500,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 7500,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 6000,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 7500,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 7500,
    },

    // weight loass and diet salads

    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 4399,
    },
    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 4399,
    },
    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 4399,
    },

    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 5499,
    },
    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 5499,
    },
    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 5499,
    },

    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 4799,
    },
    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 4799,
    },
    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 4799,
    },

    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 4499,
    },
    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 4499,
    },
    {
      goal: "Weight Loss",
      diet: "Salads",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 4499,
    },

    // balanced weight diet  Low Carb & High Protein
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 4899,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 6199,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 4999,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 4899,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 6599,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 5499,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 4899,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 5130,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 4999,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 4699,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 5499,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 4699,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 4714,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 5799,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 4999,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 4999,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 6799,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 4999,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 4999,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 5460,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 4799,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 4799,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 5899,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 4599,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 6000,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 7500,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 7500,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 6000,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 7500,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 7500,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 6000,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 7500,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 7500,
    },

    // balanced weight deit salads

    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 4399,
    },
    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 4399,
    },
    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 4399,
    },

    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 5499,
    },
    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 5499,
    },
    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 5499,
    },

    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 4799,
    },
    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 4799,
    },
    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 4799,
    },

    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 4499,
    },
    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 4499,
    },
    {
      goal: "Balanced Weight",
      diet: "Salads",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 4499,
    },

    /// Gain muscle

    {
      goal: "Gain Muscle",
      diet: "High Protein Meals",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 5130,
    },
    {
      goal: "Gain Muscle",
      diet: "High Protein Meals",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 7499,
    },
    {
      goal: "Gain Muscle",
      diet: "High Protein Meals",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 4999,
    },

    {
      goal: "Gain Muscle",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 5499,
    },
    {
      goal: "Gain Muscle",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 5499,
    },
    {
      goal: "Gain Muscle",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 5499,
    },

    //// sport specific diet

    {
      goal: "Sport Specific Diet",
      diet: "Athletic style",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 5130,
    },
    {
      goal: "Sport Specific Diet",
      diet: "Athletic style",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 7499,
    },
    {
      goal: "Sport Specific Diet",
      diet: "Athletic style",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 4999,
    },
    {
      goal: "Sport Specific Diet",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 5499,
    },
    {
      goal: "Sport Specific Diet",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 5499,
    },
    {
      goal: "Sport Specific Diet",
      diet: "Salads",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 5499,
    },
  ];

  const weeklyPricing = [
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 1211,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 1521,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 1232,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 1211,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 1533,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 1351,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 1211,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 1267,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 1232,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 1162,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 1351,
    },
    {
      goal: "Weight Loss",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 1162,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 1169,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 1421,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 1232,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 1232,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 1582,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 1232,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 1232,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 1344,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 1183,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 1183,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 1442,
    },
    {
      goal: "Weight Loss",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 1141,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 1470,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 1750,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 1750,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 1400,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 1750,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 1750,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 1400,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 1750,
    },
    {
      goal: "Weight Loss",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 1750,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 1211,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 1512,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 1232,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 1211,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 1533,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 1351,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 1211,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 1267,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 1232,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 1162,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 1351,
    },
    {
      goal: "Balanced Weight",
      diet: "Low Carb & High Protein",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 1162,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 1169,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 1421,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 1232,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 1232,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 1582,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 1232,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 1232,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 1344,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 1183,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Break Fast",
      price: 1183,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Lunch",
      price: 1422,
    },
    {
      goal: "Balanced Weight",
      diet: "Balanced Meal",
      foodPreference: "Vegan",
      plan: "Dinner",
      price: 1141,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Break Fast",
      price: 1470,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Lunch",
      price: 1750,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Vegetarian",
      plan: "Dinner",
      price: 1750,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 1400,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 1750,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 1750,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Break Fast",
      price: 1400,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Lunch",
      price: 1750,
    },
    {
      goal: "Balanced Weight",
      diet: "Ketogenic",
      foodPreference: "Eggterian",
      plan: "Dinner",
      price: 1750,
    },

    /// Gain muscle

    {
      goal: "Gain Muscle",
      diet: "High Protein Meals",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 1267,
    },
    {
      goal: "Gain Muscle",
      diet: "High Protein Meals",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 1750,
    },
    {
      goal: "Gain Muscle",
      diet: "High Protein Meals",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 1232,
    },

    //// sport specific diet

    {
      goal: "Sport Specific Diet",
      diet: "Athletic style",
      foodPreference: "Non Vegetarian",
      plan: "Break Fast",
      price: 1267,
    },
    {
      goal: "Sport Specific Diet",
      diet: "Athletic style",
      foodPreference: "Non Vegetarian",
      plan: "Lunch",
      price: 1750,
    },
    {
      goal: "Sport Specific Diet",
      diet: "Athletic style",
      foodPreference: "Non Vegetarian",
      plan: "Dinner",
      price: 1232,
    },
  ];
  console.log(Subscriptiondata);

  const calculatePricing = () => {
    let totalPrice = 0;

    if (!Subscriptiondata || !Subscriptiondata.plan) {
      console.error("Missing subscription data or plan information.");
      return totalPrice;
    }

    const pricingArray =
      Subscriptiondata.subscriptionType === "monthly"
        ? Monthlypricing
        : weeklyPricing;

    if (!Array.isArray(pricingArray)) {
      console.error("Pricing array is not defined correctly.");
      return totalPrice;
    }

    pricingArray.forEach((e) => {
      const isPlanMatch = Array.isArray(Subscriptiondata.plan)
        ? Subscriptiondata.plan.includes(e.plan)
        : e.plan === Subscriptiondata.plan;

      if (
        e.goal === Subscriptiondata.goal &&
        e.diet === Subscriptiondata.diet &&
        e.foodPreference === Subscriptiondata.foodPreference &&
        isPlanMatch
      ) {
        totalPrice += e.price;
      }
    });

    return totalPrice;
  };

  const defaultDiscountValue = () => {
    if (Array.isArray(Subscriptiondata.plan)) {
      return Subscriptiondata.plan.length;
    } else {
      return 1;
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [cuponVerifed, setcuponVerifed] = useState(false);
  const [coupontext, setcoupontext] = useState("");

  const validationSchema = Yup.object().shape({
    couponCode: Yup.string()
      .min(5, "Coupon code must be at least 5 characters")
      .max(15, "Coupon code cannot exceed 15 characters")
      .required("Coupon code is required"),
  });

  const applyCupon = (values, { resetForm }) => {
    const expectedCuponValue = "#BHOOKRFD";
    if (values.couponCode === expectedCuponValue) {
      setcuponVerifed(true);
      setcoupontext("🎉Applied..");
    } else {
      setcuponVerifed(false);
      setcoupontext("❌ Not Applied");
    }

    resetForm();
    setShowModal(false);
  };

  const subscriptionAmount = calculatePricing();

  const subscriptionAmountAfterDiscount = () => {
    const value = defaultDiscountValue();

    if (value === 3) {
      return Math.ceil(subscriptionAmount - (subscriptionAmount * 15) / 100);
    } else if (value === 2) {
      return Math.ceil(subscriptionAmount - (subscriptionAmount * 10) / 100);
    } else if (value === 1) {
      return Math.ceil(subscriptionAmount - (subscriptionAmount * 8) / 100);
    }
  };

  const discuountPrice = subscriptionAmountAfterDiscount();
  const deliveryCharges =
    Subscriptiondata?.subscriptionType === "monthly" ? 999 : 199;
  const totalAmount = cuponVerifed
    ? discuountPrice
    : discuountPrice + deliveryCharges;

  const checkout = async () => {
    try {
      setLoading(true);
      Subscriptiondata.amount = totalAmount;

      const response = await axios.post(
        `https://api-tnnfnekj6a-uc.a.run.app/payment/recivepayment`,
        Subscriptiondata
      );

      window.location.href = response.data;
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <div className="checkoutdetailscontaoner">
        <div className="maincheckout">
          <div className="">
            <h3 className="underline text-2xl pb-2  ">Subscription Details </h3>
            {Subscriptiondata ? (
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {Object.entries(Subscriptiondata).map(([key, value]) => (
                  <li key={key} style={{ marginBottom: "3px" }}>
                    <span
                      style={{ textTransform: "capitalize" }}
                      className="keybold"
                    >
                      {" "}
                      {key.replace(/([A-Z])/g, " $1")} &nbsp;:
                    </span>{" "}
                    &nbsp;
                    {Array.isArray(value) ? value.join(", ") : value.toString()}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No subscription data found.</p>
            )}
          </div>

          <div className="bilingdiv">
            <h3 className="text-center underline text-2xl pb-4">
              Billing info
            </h3>
            <ul>
              <li className="text-m my-1">
                <p>Subscription Amount :</p>{" "}
                <p>₹{subscriptionAmount.toFixed(2)}</p>
              </li>
              <li className="text-m my-1">
                <p>Discount Amount : </p>
                <p>-₹{(subscriptionAmount - discuountPrice).toFixed(2)}</p>
              </li>
              <li>
                <p>Apply Coupon 🎫 :</p>
                <div className="text-right">
                  <button
                    className="p-1 rounded-[4px] applycuponbtn text-sm"
                    onClick={() => setShowModal(true)}
                  >
                    Apply
                  </button>
                  <p
                    className="font-semibold"
                    style={{
                      color: cuponVerifed ? "#04d085" : "red",
                    }}
                  >
                    {coupontext}
                  </p>
                </div>
              </li>
              <li className="text-m my-1">
                <p>Delivary charges :</p> <p>+₹{deliveryCharges.toFixed(2)}</p>
              </li>
              <li className="text-m my-1">
                <span> Total pricing :</span> <p>₹{totalAmount.toFixed(2)}</p>
              </li>
            </ul>
            <li className="checkoutbtncontainer">
              <p></p>
              <button
                className="checkoutbtn"
                onClick={() => checkout()}
                disabled={loading}
              >
                {loading
                  ? "Processing..."
                  : `Checkout: ₹${totalAmount.toFixed(2)}`}
              </button>
            </li>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="modalData" id="modalDataoverallclosures">
            <p className="closemodal" onClick={() => setShowModal(false)}>
              ✖
            </p>
            <div className="modalDatafromoverallCloseres">
              <h3>Apply Coupon to Get More</h3>
            </div>

            <Formik
              initialValues={{ couponCode: "" }}
              validationSchema={validationSchema}
              onSubmit={applyCupon}
            >
              {({ isSubmitting }) => (
                <Form className="modal-form">
                  <div className="form-group">
                    <Field
                      type="text"
                      id="couponCode"
                      name="couponCode"
                      placeholder="Enter your coupon code"
                      className="discountapplyfeild"
                    />
                    <ErrorMessage
                      name="couponCode"
                      component="div"
                      className="error-message"
                    />
                  </div>

                  <div className="modal-buttons ">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="applybtn"
                    >
                      Apply
                    </button>
                    <button type="button" onClick={() => setShowModal(false)}>
                      Cancel
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout;
